import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import { FC } from 'react'

// Import SVG icons
import ViewIcon from '@/assets/icons/actions/view.svg'
import AuditTrailIcon from '@/assets/icons/actions/audit-trail.svg'

// Styled IconButtons for consistent appearance
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  margin: '0 1px',
  padding: 5,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}))

// Data creation function
function createData(
  id: number,
  purpose: string,
  type: string,
  status: string,
  method: string,
  statusDate: string,
  modifiedDate: string,
) {
  return { id, purpose, type, status, method, statusDate, modifiedDate }
}

// Sample data
const data = [
  createData(
    1123,
    'Sample Data',
    'Sample Data',
    'Processed',
    'Sample Data',
    'MM/DD/YYYY',
    'MM/DD/YYYY',
  ),
  createData(
    1124,
    'Sample Data',
    'Sample Data',
    'Processed',
    'Sample Data',
    'MM/DD/YYYY',
    'MM/DD/YYYY',
  ),
  createData(
    1125,
    'Sample Data',
    'Sample Data',
    'Processed',
    'Sample Data',
    'MM/DD/YYYY',
    'MM/DD/YYYY',
  ),
]

// Functional component
export const UserManagementTable: FC = () => {
  return (
    <TableContainer component={Paper} sx={{ padding: 2, minHeight: '75vh' }}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            sx={{
              border: '1px solid #EFF0F4',
              '& th': {
                borderBottom: '1px solid #EFF0F4',
                fontSize: 14, // Font size for header cells
              },
            }}
          >
            <TableCell>ID</TableCell>
            <TableCell align="right">Purpose</TableCell>
            <TableCell align="right">Type of Concern</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Method of Repair</TableCell>
            <TableCell align="right">Status Date</TableCell>
            <TableCell align="right">Modified Date</TableCell>
            <TableCell align="center">Action </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow
              key={row.id}
              sx={{
                border: 'none',
                '& td, & th': {
                  border: 'none',
                  fontSize: 12, // Font size for body cells
                },
              }}
            >
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell align="right">{row.purpose}</TableCell>
              <TableCell align="right">{row.type}</TableCell>
              <TableCell align="right">{row.status}</TableCell>
              <TableCell align="right">{row.method}</TableCell>
              <TableCell align="right">{row.statusDate}</TableCell>
              <TableCell align="right">{row.modifiedDate}</TableCell>
              <TableCell
                align="center"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <StyledIconButton>
                  <img
                    src={ViewIcon}
                    alt="View"
                    style={{ width: 16, height: 16 }}
                  />
                </StyledIconButton>
                <StyledIconButton>
                  <img
                    src={AuditTrailIcon}
                    alt="Audit Trail"
                    style={{ width: 16, height: 16 }}
                  />
                </StyledIconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
